export default [
  {
    path: "/settings",
    name: "settings",
    component: () => import("@/views/settings/Settings.vue"),
    meta: {
      Permission: "no_permission_required",
    },
  },

  {
    path: "/settings/actions-timeline",
    name: "settings-actions-timeline",
    component: () => import("@/views/settings/Timeline/Timeline.vue"),
    meta: {
      Permission: "no_permission_required",
    },
  },

  // PERMISSIONS
  {
    path: "/settings/userrole",
    name: "settings-userrole",
    component: () =>
      import("@/views/settings/Permissions/role-list/RoleList.vue"),
    meta: {
      Permission: "no_permission_required",
    },
  },

  // Pillars
  {
    path: "/settings/settings-dashboard/pillars",
    name: "settings-pillars",
    component: () => import("@/views/settings/Pillar/Pillar.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  {
    path: "/settings/settings-dashboard/pillar-add",
    name: "settings-pillar-add",
    component: () => import("@/views/settings/Pillar/PillarAdd.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  {
    path: "/settings/settings-dashboard/pillar-edit/:id",
    name: "settings-pillar-edit",
    component: () => import("@/views/settings/Pillar/PillarEdit.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  // companies
  {
    path: "/settings/settings-dashboard/companies",
    name: "settings-companies",
    component: () => import("@/views/settings/Company/Company.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },
  




  {
    path: "/settings/settings-dashboard/company-add",
    name: "settings-company-add",
    component: () => import("@/views/settings/Company/CompanyAdd.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  {
    path: "/settings/settings-dashboard/company-edit/:id",
    name: "settings-company-edit",
    component: () => import("@/views/settings/Company/CompanyEdit.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

    // SITES
  {
    path: "/settings/settings-dashboard/sites",
    name: "settings-sites",
    component: () => import("@/views/settings/Site/Site.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

    {
    path: "/settings/settings-dashboard/site-add",
    name: "settings-site-add",
    component: () => import("@/views/settings/Site/SiteAdd.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  {
    path: "/settings/settings-dashboard/site-edit/:id",
    name: "settings-site-edit",
    component: () => import("@/views/settings/Site/SiteEdit.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  // pillar titles
  {
    path: "/settings/settings-dashboard/pillar-titles",
    name: "settings-pillar-titles",
    component: () => import("@/views/settings/PillarTitle/PillarTitle.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  {
    path: "/settings/settings-dashboard/pillar-title-add",
    name: "settings-pillar-title-add",
    component: () => import("@/views/settings/PillarTitle/PillarTitleAdd.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  {
    path: "/settings/settings-dashboard/pillar-title-edit/:id",
    name: "settings-pillar-title-edit",
    component: () => import("@/views/settings/PillarTitle/PillarTitleEdit.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  // objective
  {
    path: "/settings/settings-dashboard/objectives",
    name: "settings-objectives",
    component: () => import("@/views/settings/Objective/Objective.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  {
    path: "/settings/settings-dashboard/objective-add",
    name: "settings-objective-add",
    component: () => import("@/views/settings/Objective/ObjectiveAdd.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  {
    path: "/settings/settings-dashboard/objective-edit/:id",
    name: "settings-objective-edit",
    component: () => import("@/views/settings/Objective/ObjectiveEdit.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  // action
  {
    path: "/settings/settings-dashboard/actions",
    name: "settings-actions",
    component: () => import("@/views/settings/Action/Action.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  {
    path: "/settings/settings-dashboard/action-add",
    name: "settings-action-add",
    component: () => import("@/views/settings/Action/ActionAdd.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  {
    path: "/settings/settings-dashboard/action-edit/:id",
    name: "settings-action-edit",
    component: () => import("@/views/settings/Action/ActionEdit.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  // kpi
  {
    path: "/settings/settings-dashboard/kpis",
    name: "settings-kpis",
    component: () => import("@/views/settings/KPI/KPI.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  {
    path: "/settings/settings-dashboard/kpi-add",
    name: "settings-kpi-add",
    component: () => import("@/views/settings/KPI/KPIAdd.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  {
    path: "/settings/settings-dashboard/kpi-edit/:id",
    name: "settings-kpi-edit",
    component: () => import("@/views/settings/KPI/KPIEdit.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  // narrative
  {
    path: "/settings/settings-dashboard/narratives",
    name: "settings-narratives",
    component: () => import("@/views/settings/Narrative/Narrative.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  {
    path: "/settings/settings-dashboard/narrative-add",
    name: "settings-narrative-add",
    component: () => import("@/views/settings/Narrative/NarrativeAdd.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  {
    path: "/settings/settings-dashboard/narrative-edit/:id",
    name: "settings-narrative-edit",
    component: () => import("@/views/settings/Narrative/NarrativeEdit.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  // CSFs
  {
    path: "/settings/settings-dashboard/critical-success-factors",
    name: "settings-csfs",
    component: () => import("@/views/settings/CSF/CSF.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  {
    path: "/settings/settings-dashboard/csf-add",
    name: "settings-csf-add",
    component: () => import("@/views/settings/CSF/CSFAdd.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  {
    path: "/settings/settings-dashboard/csf-edit/:id",
    name: "settings-csf-edit",
    component: () => import("@/views/settings/CSF/CSFEdit.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  // owner
  {
    path: "/settings/settings-dashboard/owners",
    name: "settings-owners",
    component: () => import("@/views/settings/Owner/Owner.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  {
    path: "/settings/settings-dashboard/owner-add",
    name: "settings-owner-add",
    component: () => import("@/views/settings/Owner/OwnerAdd.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  {
    path: "/settings/settings-dashboard/owner-edit/:id",
    name: "settings-owner-edit",
    component: () => import("@/views/settings/Owner/OwnerEdit.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  // priorities
  {
    path: "/settings/settings-dashboard/priorities",
    name: "settings-priorities",
    component: () => import("@/views/settings/Priority/Priority.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  {
    path: "/settings/settings-dashboard/priority-add",
    name: "settings-priority-add",
    component: () => import("@/views/settings/Priority/PriorityAdd.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  {
    path: "/settings/settings-dashboard/priority-edit/:id",
    name: "settings-priority-edit",
    component: () => import("@/views/settings/Priority/PriorityEdit.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  // working groups
  {
    path: "/settings/settings-dashboard/working-groups",
    name: "settings-working-groups",
    component: () => import("@/views/settings/WorkingGroup/WorkingGroup.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  {
    path: "/settings/settings-dashboard/working-group-add",
    name: "settings-working-group-add",
    component: () =>
      import("@/views/settings/WorkingGroup/WorkingGroupAdd.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  {
    path: "/settings/settings-dashboard/working-group-edit/:id",
    name: "settings-working-group-edit",
    component: () =>
      import("@/views/settings/WorkingGroup/WorkingGroupEdit.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  // courses
  {
    path: "/settings/settings-dashboard/courses",
    name: "settings-courses",
    component: () => import("@/views/settings/Course/Course.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  {
    path: "/settings/settings-dashboard/course-add",
    name: "settings-course-add",
    component: () => import("@/views/settings/Course/CourseAdd.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  {
    path: "/settings/settings-dashboard/course-edit/:id",
    name: "settings-course-edit",
    component: () => import("@/views/settings/Course/CourseEdit.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  // cpd imports
  {
    path: "/settings/settings-dashboard/imports",
    name: "settings-imports",
    component: () => import("@/views/settings/Import/Import.vue"),
    meta: {
      Permission: "view_import_btn",
      navActiveLink: "settings-dashboard",
    },
  },

  // venues
  {
    path: "/settings/settings-dashboard/venues",
    name: "settings-venues",
    component: () => import("@/views/settings/Venue/Venue.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  // trainers
  {
    path: "/settings/settings-dashboard/trainers",
    name: "settings-trainers",
    component: () => import("@/views/settings/Trainer/Trainer.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  // risk categories
  {
    path: "/settings/settings-dashboard/risk-categories",
    name: "settings-risk-categories",
    component: () => import("@/views/settings/RiskCategory/RiskCategory.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },
  {
    path: "/settings/settings-dashboard/risk-category-add",
    name: "settings-risk-category-add",
    component: () => import("@/views/settings/RiskCategory/RiskCategoryAdd.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },
  {
    path: "/settings/settings-dashboard/risk-category-edit/:id",
    name: "settings-risk-category-edit",
    component: () => import("@/views/settings/RiskCategory/RiskCategoryAdd.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  // risk objectives ("Risk" field)
  {
    path: "/settings/settings-dashboard/risk-objectives",
    name: "settings-risk-objectives",
    component: () => import("@/views/settings/RiskObjective/RiskObjective.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },
  {
    path: "/settings/settings-dashboard/risk-objective-add",
    name: "settings-risk-objective-add",
    component: () => import("@/views/settings/RiskObjective/RiskObjectiveAdd.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },
  {
    path: "/settings/settings-dashboard/risk-objective-edit/:id",
    name: "settings-risk-objective-edit",
    component: () => import("@/views/settings/RiskObjective/RiskObjectiveAdd.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  // risk impacts ("Potential Impact" field)
  {
    path: "/settings/settings-dashboard/risk-impacts",
    name: "settings-risk-impacts",
    component: () => import("@/views/settings/RiskImpact/RiskImpact.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },
  {
    path: "/settings/settings-dashboard/risk-impact-add",
    name: "settings-risk-impact-add",
    component: () => import("@/views/settings/RiskImpact/RiskImpactAdd.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },
  {
    path: "/settings/settings-dashboard/risk-impact-edit/:id",
    name: "settings-risk-impact-edit",
    component: () => import("@/views/settings/RiskImpact/RiskImpactAdd.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  // risk mitigation actions
  {
    path: "/settings/settings-dashboard/risk-mitigation-actions",
    name: "settings-risk-mitigation-actions",
    component: () => import("@/views/settings/RiskMitigationAction/RiskMitigationAction.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },
  {
    path: "/settings/settings-dashboard/risk-mitigation-action-add",
    name: "settings-risk-mitigation-action-add",
    component: () => import("@/views/settings/RiskMitigationAction/RiskMitigationActionAdd.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },
  {
    path: "/settings/settings-dashboard/risk-mitigation-action-edit/:id",
    name: "settings-risk-mitigation-action-edit",
    component: () => import("@/views/settings/RiskMitigationAction/RiskMitigationActionAdd.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },

  // risk future actions
  {
    path: "/settings/settings-dashboard/risk-future-actions",
    name: "settings-risk-future-actions",
    component: () => import("@/views/settings/RiskFutureAction/RiskFutureAction.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },
  {
    path: "/settings/settings-dashboard/risk-future-action-add",
    name: "settings-risk-future-action-add",
    component: () => import("@/views/settings/RiskFutureAction/RiskFutureActionAdd.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },
  {
    path: "/settings/settings-dashboard/risk-future-action-edit/:id",
    name: "settings-risk-future-action-edit",
    component: () => import("@/views/settings/RiskFutureAction/RiskFutureActionAdd.vue"),
    meta: {
      Permission: "no_permission_required",
      navActiveLink: "settings-dashboard",
    },
  },
];
